/* =========================================================================
 * 도움말 첫 화면 "영상으로 배우기" — 재생목록 카드 전환 애니메이션 (DocsPlaylistCard)
 *
 * 재생을 누르면 배치가 바뀌면서 썸네일이 플레이어 자리로 커지며 옮겨 간다(View Transitions).
 * 기본값(0.25s)은 크기가 크게 바뀌는 이동엔 툭 끊겨 보여서 조금 늘리고 끝을 감속한다.
 *
 * 전환 의사요소(::view-transition-*)는 문서 루트에 붙어 CSS 를 컴포넌트 안에 가둘 수
 * 없다. 그래서 `view-transition-class` 로 **이 카드들만** 고른다 — 다른 화면이 전환을
 * 써도 이 값이 새지 않는다. 클래스를 모르는 브라우저는 이 규칙을 건너뛰고 기본 속도로 움직인다.
 * ========================================================================= */
.docs-playlist-card {
  view-transition-class: docs-playlist;
}

::view-transition-group(*.docs-playlist) {
  animation-duration: 0.42s;
  animation-timing-function: cubic-bezier(0.2, 0, 0, 1);
}
